import { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import CardActionButton from '../../../components/CardActionButton';
import Iconify from '../../../components/Iconify';
import TabsPageLayout from '../../../components/TabsPageLayout';
import { PORTAL_ROUTE } from '../../../constants/routes';
import { useApplication } from '../../../hooks/applications';
import { WDAC_APP_PREVIOUS_PATH } from '../../wdac-results/tabs/Win32Apps/constants';

const AppDetails = () => {
  const { appId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const backNavigationPath = location.state?.backTo || `${PORTAL_ROUTE}/apps`;
  const { data: apps } = useApplication({ applicationId: appId });
  const globalApplicationVersionId = apps?.globalApplicationVersionId;

  const tabs = useMemo(
    () => [
      {
        label: 'General',
        value: `${PORTAL_ROUTE}/apps/${appId}/general`,
      },
      {
        label: 'Details',

        value: `${PORTAL_ROUTE}/apps/${appId}/details`,
      },
    ],
    [appId],
  );

  // This import is one file set of a Win32 app, which opens on its general tab. The app page's
  // back button returns here.
  const openApplication = () => {
    sessionStorage.setItem(WDAC_APP_PREVIOUS_PATH, location.pathname);
    navigate(`${PORTAL_ROUTE}/wdac-apps/${globalApplicationVersionId}/general`);
  };

  return (
    <TabsPageLayout
      hasBackButton
      title={
        <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
          <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
            {apps?.environmentApplicationName}
            {apps ? (
              <Box component="span" sx={{ color: '#cdf3ceff', fontSize: '0.9em', fontWeight: 400 }}>
                (File Set Import)
              </Box>
            ) : null}
          </Box>
          {globalApplicationVersionId ? (
            <CardActionButton
              onClick={openApplication}
              sx={{ fontSize: '12px', padding: '2px 10px', flexShrink: 0 }}
              startIcon={<Iconify icon="mdi:open-in-app" width={15} height={15} />}>
              Open Application
            </CardActionButton>
          ) : null}
        </Box>
      }
      tabs={tabs}
      backNavigationPath={backNavigationPath}
      wrapperProps={{
        sx: {
          maxWidth: '100%',
        },
      }}
      titleProps={{
        fontSize: '1.4rem',
      }}
    />
  );
};

export default AppDetails;
